import { useSessionFlag } from "hooks/useSessionFlag";
import { useMemo } from "react";
import { isActivityRecent } from "utils";

export function useIsEmergencyContactEnabled(activity: { openDate: string }) {
    const launchDate = useSessionFlag<string>('emergency-contact-launch-date');
    const isNewActivity = useMemo(() => isActivityRecent(activity, launchDate), [activity, launchDate]);
    return isNewActivity;
}